import React, { useContext } from 'react';
import { t } from '@lingui/macro';
import { Dialog, Icon } from '@economic/taco';

import { CustomFinalIconProps, ProgressDots } from '~/app/shared/components/ui/progressDots/ProgressDots';
import { SmartPayOnboardingSteps } from '../../../../../types';
import { useSignupDialogNavigation } from '../../hooks/useSignupDialogNavigation';
import { SignupDialogOnboardingContext } from '../../contexts/SignupDialogOnboardingContextProvider';

const SignupDialogTitle = () => {
    const onboardingContext = useContext(SignupDialogOnboardingContext);
    const { onboardError } = onboardingContext!;
    const { currentStep, currentStepIndex, stepsCount, isLoading } = useSignupDialogNavigation();

    const title = () => {
        if (isLoading || onboardError) return '';

        switch (currentStep) {
            case SmartPayOnboardingSteps.OVERVIEW:
                return t`Start setting up Smart Pay`;
            case SmartPayOnboardingSteps.USER_INFORMATION:
                return t`Your information`;
            case SmartPayOnboardingSteps.COMPANY_INFORMATION:
                return t`Company information`;
            case SmartPayOnboardingSteps.PLAN:
                return t`Select price model`;
            case SmartPayOnboardingSteps.SUCCESS:
                return t`You are now forwarded to November First`;
            default:
                return '';
        }
    };

    const icon = ({ index, currentIndex }: CustomFinalIconProps) => (
        <Icon
            name="november-first"
            className="max-h-5 max-w-5"
            style={index > currentIndex ? { filter: 'grayscale(100%) invert()' } : {}}
        />
    );

    return (
        <Dialog.Title>
            <ProgressDots
                stepsCount={stepsCount}
                currentStep={currentStepIndex}
                withCompleteTicks={false}
                customFinalIcon={icon}
            />
            <div className="text-left mt-4">{title()}</div>
        </Dialog.Title>
    );
};

export default SignupDialogTitle;
